import { useEffect, useState } from "react";
import { extendUserTokenApi, fetchPagesApi, getUserTokensApi, savePagesApi, } from "../apiServices/fbTokenServices";

const useFbTokenSetup = () => {

  const [userTokens, setUserTokens] = useState([]);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserTokens = async () => {
    try {
      const res = await getUserTokensApi();
      setUserTokens(res?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const extendUserToken = async (accessToken) => {
    setLoading(true);

    try {
      const res = await extendUserTokenApi({ accessToken });
      return res;
    } finally {
      setLoading(false);
    }
  };

  const fetchPages = async (userTokenId) => {
    setLoading(true);

    try {
      const res = await fetchPagesApi({ userTokenId });
      setPages(res?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const savePages = async (userTokenId, selectedPages) => {
    setLoading(true);

    try {
      return await savePagesApi({
        userTokenId,
        pages: selectedPages,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserTokens();
  }, []);

  return { loading, pages, userTokens, fetchPages, savePages, extendUserToken, };
};

export default useFbTokenSetup;